export default __webpack_public_path__ + "static/media/longchamp28.2ccf77a8.jpg";